import {createMenu, FallDownMenu, IMenuItem} from "../models/elements/FallDownMenu.js";
import JSX from "../helpers/react.js";
// import {VideoSelectorsAdapter} from "./videoselector/videoselector.js";


function menuItems(): IMenuItem[] {
    return [
        {
            type: "bool",
            icon: "adjust",
            text: "Новый дизайн",
            active: localStorage['designSwitch'] !== 'false',
            onClick() {
                const active = localStorage.designSwitch !== 'false';
                localStorage.designSwitch = !(active) + "";
                (window as any)?._onchangeOldDesign(active);
            }
        },
        {
            type: "bool",
            icon: "expand",
            class: "expand",
            text: "Расширить плеер",
            active: $('body').hasClass('big-player'),
            onClick() {
                $('body').toggleClass('big-player');
            }
        },
        {
            type: 'bool',
            icon: 'step-forward',
            class: 'step-forward',
            text: 'Автопропуск серий',
            active: localStorage.autoSkipNextEp !== 'false',
            onClick(v) {
                localStorage.autoSkipNextEp = v ? 'true' : 'false';
            }
        }
    ];
}

$("html").on('click', '.player-settings', function () {
    createMenu(
        <FallDownMenu
            items={menuItems()}
            position={this}
            title="Настройки плеера"
        />
    );
})


